import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button, Slide, useTheme, useMediaQuery, Typography, Box, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Markdown from 'markdown-to-jsx';
import { trackButtonClick } from '../segment/segmentModule';
import { HOME_STEP } from '../routing/flowConstants';
import currencyLocalMessages from '../localeCurrencyPicker/messages/LocaleCurrencyMessages';


const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

const NewFeatureInfoPopUp = ({
    intl, isOpen, handleCloseModel, title, message, trackAddAnotherButton
}) => {
    const handleClose = () => {
        handleCloseModel(false);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={isOpen}
            fullWidth
            TransitionComponent={isMobile ? Transition : undefined}
            onClose={handleClose}
            className='new-feature-info-popup-dialog'
            aria-labelledby='new-feature-info-popup-heading'
        >
            <Box className='new-feature-info-popup-heading-container'>
                <Typography
                    variant='h2'
                    className='new-feature-info-popup-heading'
                    id="new-feature-info-popup-heading"
                >
                    {title}
                </Typography>
                <IconButton
                    className='new-feature-info-popup-close-icon'
                    aria-label='Close category dialog'
                    onClick={() => { handleClose(); }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent className='new-feature-info-popup-content'>
                <Markdown
                    className='new-feature-info-popup-text'
                    variant='caption'
                >
                    {message}
                </Markdown>
            </DialogContent>
            <DialogActions className='new-feature-info-popup-actions'>
                <Button
                    className='new-feature-info-popup-button'
                    variant='outlined'
                    onClick={() => {
                        handleClose();
                        trackAddAnotherButton(
                            intl.formatMessage(currencyLocalMessages.gotItButtonText),
                            HOME_STEP, 'new_feature_info_popup'
                        );
                    }}
                >
                    {intl.formatMessage(currencyLocalMessages.gotItButtonText)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

NewFeatureInfoPopUp.propTypes = {
    
    intl: intlShape.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleCloseModel: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    trackAddAnotherButton: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    trackAddAnotherButton: trackButtonClick
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewFeatureInfoPopUp));
